/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-mixed-operators */
import React, { useEffect, useState } from "react";
import { DividerProps } from "rc-menu/lib/Divider";
import "./../../assets/scss/components/cards.scss";
import { useNavigate } from "react-router-dom";
import { Actions } from "../../utils";
import { getMoods, getTempos } from "../../actions/user";
import * as Genre from "./../../actions/genre";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../../types/models/store";
import { LoadingWidget } from "../widgets/loading";
import { APP_DOMAIN } from "../../constants";
import { Backend } from "shared-types";

export interface TableCardProps extends DividerProps {
    key?: string;
    loading: boolean;
    danger?: boolean;
    title: string;
    data: CardData[];
    headers: CardHeaderItem[];
    actions?: Actions[];
    icon?: boolean;
    check?: string;
    select?: boolean;
    filterable?: boolean;
    more?: string;
    detailData?: any;
    selectedRow?: number;
    onClickEdit?: (id: number) => void;
    onClickAdd?: (id: number) => void;
    onClickDelete?: (id: number) => void;
    onClickDetail?: (id: number) => void;
    onClickPlus?: (id: number) => void;
    setSelectedRow?: (id: number) => void;
}

export interface CardHeaderItem {
    title: string;
    width?: string;
}

export interface CardDataItem {
    title?: string;
    comment?: string;
    cell?: string;
    genre?: string;
    mood?: string;
    tempo?: string;
    type?: string;
    array?: string[];
}

export interface CardData {
    icon?: string;
    id: number;
    data: CardDataItem[];
    params?: any;
}

export const headerItem = (title: string, width: string = ''): CardHeaderItem => {
    return {
        title: title,
        width: width
    }
}

const TableCard: React.FC<TableCardProps> = (props: TableCardProps) => {
    const dispatch = useDispatch();
    const { selected_tracks } = useSelector((state: StoreState) => state.toolbar);

    const [genreList, setGenreList] = useState<Backend.T_Genre[]>([]);
    const [moodList, setMoodList] = useState<Backend.T_Mood[]>([]);
    const [tempoList, setTempoList] = useState<Backend.T_Tempo[]>([]);

    const navigate = useNavigate();
    const [data, setData] = useState<CardData[]>([]);
    const [filter, setFilter] = useState("");
    const [checkAll, setCheckAll] = useState(false);
    const [checkOne, setCheckOne] = useState<boolean[]>();
    // const checkParam = props.check === 'TRACK' ? COOKIE_PARAMS.SELECTED.TRACK : "unknown";

    useEffect(() => {
        setData(props.data);
        if (props.data.length && props.data[0].data.length) {
            props.data[0].data?.map((c: any) => {
                Object.keys(c).forEach((key) => {
                    if (key === 'genre' && !genreList.length) {
                        Genre.all().then((data) => {
                            setGenreList(data);
                        });
                    }
                });
                Object.keys(c).forEach((key) => {
                    if (key === 'mood' && !genreList.length) {
                        getMoods().then((data) => {
                            setMoodList(data);
                        });
                    }
                });
                Object.keys(c).forEach((key) => {
                    if (key === 'tempo' && !genreList.length) {
                        getTempos().then((data) => {
                            setTempoList(data);
                        });
                    }
                });
            });
        }
    }, [props.data]);

    useEffect(() => {
        if (props.filterable) {
            if (filter === '') setData(props.data);
            else
                setData(data.filter((row: any) => {
                    return row.data.filter((col: any) =>
                        col.cell && col.cell.toLowerCase().indexOf(filter.toLowerCase()) > -1 ||
                        col.title && col.title.indexOf(filter) > -1 ||
                        col.comment && col.comment.indexOf(filter) > -1
                    ).length > 0;
                }));
        }
    }, [filter]);

    useEffect(() => {
        let checkArray = [];
        for (var i = 0; i < props.data.length; i++) {
            if (selected_tracks.filter((a: any) => a.id == props.data[i].id).length) checkArray[i] = true;
            else checkArray[i] = false;
        }
        setCheckOne(checkArray);
    }, [selected_tracks]);

    const setCheckAction = (index: number) => {
        let check_array = checkOne?.length ? checkOne : [];

        if (index < 0) {
            setCheckAll(!checkAll);
            for (var i = 0; i < data.length; i++) {
                check_array[i] = !checkAll;
            }
        } else {
            check_array[index] = !check_array[index];
        }

        if (props.check === 'TRACK') {
            let ids = [];
            for (var j = 0; j < data.length; j++) {
                if (check_array[j])
                    ids.push({
                        id: data[j].id,
                        title: data[j].data[0].title,
                        cover: data[j].icon,
                        singer: data[j].data[2].cell,
                        file: data[j].params?.file,
                    });
            }
            for (var i = 0; i < selected_tracks.length; i++) {
                if (!data.filter((d: any) => d.id === selected_tracks[i].id).length) ids.push(selected_tracks[i]);
            }
            dispatch({
                type: "SET_SELECTED_TRACKS",
                payload: ids
            });
        }
        setCheckOne([...check_array]);
    }

    return (
        <div className={`table-card ${props.className}`} key={"table_" + props.key + "_" + props.title}>
            {props.title && (<div className="card-header d-flex justify-content-between">
                <div>{props.title}</div>
                {props.filterable ? (
                    <div className="search-header w-50">
                        <input className="w-100" type={'text'} value={filter} onChange={(e) => setFilter(e.target.value)} placeholder={"search"} />
                    </div>
                ) : (<></>)}
                {props.more !== "" && props.more !== undefined ? (
                    <>
                        {props.more.includes('http') ? (
                            <>
                                <div className="more-btn-header focus" onClick={() => window.open(props.more + "")}>More</div>
                            </>
                        ) : (<>
                            <div className="more-btn-header focus" onClick={() => navigate(props.more + "")}>
                                More
                            </div>
                        </>)}
                    </>

                ) : (<></>)}
            </div>)}
            <div className="card-body flex-col">
                <table>
                    <thead>
                        <tr>
                            {props.check && (
                                <th key={"thead_chk"}>
                                    <span
                                        className="chk d-flex focus"
                                        onClick={() => setCheckAction(-1)}
                                    >
                                        <img className="chk" src={`imgs/checkbox-${checkAll ? "" : "un"}checked-all.svg`} alt="" />
                                    </span>
                                </th>
                            )}
                            {/* {props.icon === true && (
                                <th key={"thead_icon"} colSpan={2}><span>#</span></th>
                            )} */}
                            {props.headers?.map((header: CardHeaderItem, index: number) => (
                                <th key={"thead_" + index} colSpan={props.icon === true && index === 0 ? 2 : 1}><span>{header.title}</span></th>
                            ))}
                            {props.actions && props.actions.length ? (
                                <th key={"thead_action"}><span>Actions</span></th>
                            ) : (<></>)}
                        </tr>
                    </thead>
                    <tbody>
                        {props.loading && (
                            <tr><td colSpan={props.headers.length + (props.check ? 1 : 0) + (props.icon ? 1 : 0) + (props.actions ? 1 : 0)}>
                                <LoadingWidget />
                            </td></tr>
                        )}
                        {!props.loading && data?.map((row: CardData, index: number) => {
                            return (
                                <>
                                    <tr
                                        key={index}
                                        className={`card-data align-center focus` + (props.selectedRow && props.selectedRow === row.id ? ` active` : ``)}
                                        onClick={() => {
                                            props.setSelectedRow && props.setSelectedRow(row.id)
                                        }}
                                    >
                                        {props.check && (
                                            <td style={{ minWidth: '30px' }}>
                                                <div
                                                    className="cell-content chk focus mt-1"
                                                    onClick={() => setCheckAction(index)}
                                                >
                                                    <img className="chk" src={`imgs/checkbox-${checkOne && checkOne[index] ? "" : "un"}checked.svg`} width={'20px'} height={'20px'} alt="" />
                                                </div>
                                            </td>
                                        )}
                                        {props.icon === true && (
                                            <td style={{ minWidth: '50px' }}>
                                                <div className="vertical-bar" />
                                                <div className="cell-content">
                                                    {props.title.includes('TRACK---') ? (
                                                        <a target="_blank" href={`${APP_DOMAIN}dashboard/track/${row.id}&${row.params?.file}`}>
                                                            <img className="logo" src={row.icon} alt="" width={`40px`} height={`40px`} />
                                                        </a>
                                                    ) : (<img className="logo" src={row.icon} alt="" width={`40px`} height={`40px`} />)
                                                    }
                                                </div>
                                            </td>
                                        )}
                                        {row.data?.map((item: CardDataItem, idx: number) => {
                                            return (
                                                <td key={idx} style={{
                                                    width: `${props.headers[idx]?.width ? props.headers[idx].width : 'unset'}`,
                                                    minWidth: `${props.headers[idx]?.width ? props.headers[idx].width : 'unset'}`
                                                }}>
                                                    <div className="cell-content">
                                                        {item.type && item.type === 'icon' && <div className="cell"><img className="logo" src={row.icon} alt="" width={`40px`} height={`40px`} /></div>}
                                                        {
                                                            item.title && (
                                                                props.danger ? (
                                                                    <div className="title" dangerouslySetInnerHTML={{ __html: item.title }} />
                                                                ) : (
                                                                    <div className="title">{item.title}</div>
                                                                )
                                                            )
                                                        }
                                                        {item.cell && (
                                                            props.danger ? (
                                                                <div className="cell" dangerouslySetInnerHTML={{ __html: item.cell }} />
                                                            ) : (
                                                                <div className="cell">{item.cell}</div>
                                                            )
                                                        )}
                                                        {item.comment && <div className="comment">{item.comment}</div>}
                                                        {item.array && item.array.length && item.array?.map((v: string, cell_index: number) => (
                                                            <div key={cell_index} className="cell">{v}</div>
                                                        ))}
                                                        {item.genre && <div className="cell">{
                                                            genreList.filter(
                                                                (g: any) => g.id === item.genre
                                                            ).length > 0 ? (
                                                                genreList.filter(
                                                                    (g: any) => g.id === item.genre
                                                                )[0]?.title
                                                            ) : ''}</div>
                                                        }
                                                        {item.mood && <div className="cell">{
                                                            moodList.filter(
                                                                (g: any) => g.id === item.mood
                                                            ).length > 0 ? (
                                                                moodList.filter(
                                                                    (g: any) => g.id === item.mood
                                                                )[0]?.title
                                                            ) : ''}</div>
                                                        }
                                                        {item.tempo && <div className="cell">{
                                                            tempoList.filter(
                                                                (g: any) => g.id === item.tempo
                                                            ).length > 0 ? (
                                                                tempoList.filter(
                                                                    (g: any) => g.id === item.tempo
                                                                )[0]?.title
                                                            ) : ''}</div>
                                                        }
                                                    </div>
                                                </td>
                                            )
                                        })}
                                        {(props.actions && props.actions.length) ? (
                                            <td className="actions" style={{ width: `${props.actions.length * 32}px` }}>
                                                <div className="cell-content d-flex">
                                                    {props.actions?.map((action: Actions, idx: number) => {
                                                        if (action === Actions.add) {
                                                            return <img key={idx} className="focus" src="imgs/track_plus.svg" alt="add" style={{ width: '14px' }}
                                                                onClick={() => {
                                                                    if (props.onClickAdd) props.onClickAdd(row.id);
                                                                }}
                                                            />
                                                        }
                                                        if (action === Actions.delete) {
                                                            return <img key={idx} className="focus" src="imgs/track_delete.svg" alt="delete"
                                                                onClick={() => {
                                                                    if (props.onClickDelete) props.onClickDelete(row.id);
                                                                }}
                                                            />
                                                        }
                                                        if (action === Actions.edit) {
                                                            return <img key={idx} className="focus" src="imgs/track_edit.svg" alt="edit" style={{ width: '14px' }}
                                                                onClick={() => {
                                                                    if (props.onClickEdit) props.onClickEdit(row.id);
                                                                }}
                                                            />
                                                        }
                                                        if (action === Actions.detail) {
                                                            return <img key={idx} className="focus" src="imgs/track_analyze.svg" alt="edit" style={{ width: '14px' }}
                                                                onClick={() => {
                                                                    if (props.onClickDetail) props.onClickDetail(row.id);
                                                                }}
                                                            />
                                                        }
                                                        if (action === Actions.duplicate) {
                                                            return <img key={idx} className="focus" src="imgs/track_plus.svg" alt="duplicate" style={{ width: '14px' }}
                                                                onClick={() => {
                                                                    if (props.onClickPlus) props.onClickPlus(row.id);
                                                                }}
                                                            />
                                                        }
                                                    })}
                                                </div>
                                            </td>
                                        ) : (<></>)}
                                    </tr>
                                    {props.detailData && props.detailData.id === row.id ? (
                                        <>
                                            <tr></tr>
                                            <tr>
                                                <td className="detail-wrapper" colSpan={row.data.length + (props.icon === true ? 1 : 0) + (props.actions && props.actions.length ? 1 : 0)}>
                                                    <div className="detail-view" dangerouslySetInnerHTML={{
                                                        __html: props.detailData.data
                                                    }}></div>
                                                </td>
                                            </tr>

                                        </>
                                    ) : (<></>)}
                                </>
                            )
                        })}
                    </tbody>
                </table>

            </div>
        </div>
    )
}

export default TableCard;